export const tableListData = [
  {
    key: 'distanceFromBts',
    text: 'Distance from BTS / MRT',
    type: 'normal',
  },
  {
    key: 'floor',
    text: 'Floor',
    type: 'normal',
  },
  {
    key: 'totalUnits',
    text: 'Total Units',
    type: 'normal',
  },
  {
    key: 'parkingLot',
    text: 'Parking Lot',
    type: 'normal',
  },
  {
    key: 'yearLaunch',
    text: 'Launch Year',
    type: 'normal',
  },
  {
    key: 'yearComplete',
    text: 'Completed Year',
    type: 'normal',
  },
  {
    key: 'launchPriceSqm',
    text: 'Package Price (Launch/Current)',
    type: 'price1',
  },
  {
    key: 'currentPriceSqm',
    text: '',
    type: 'price2',
  },
  {
    key: 'launchPriceSqm',
    text: 'Price/Sq.m (Launch/Current)',
    type: 'price1',
  },
  {
    key: 'currentPriceSqm',
    text: '',
    type: 'price2',
  },
  {
    key: 'resalePriceSqm',
    text: 'Avg.Resale Price',
    type: 'normal',
  },
  {
    key: 'percentSold',
    text: '% Sold (Admin)',
    type: 'admin',
  },
  {
    key: 'unitsLeft',
    text: 'Units Left (Admin)',
    type: 'admin',
  },
  {
    key: 'furniturePackage',
    text: 'Furniture Package',
    type: 'normal',
  },
  {
    key: 'unitsType',
    text: 'Units Type',
    type: 'normal',
  },
  {
    key: 'ceiling',
    text: 'Ceiling',
    type: 'normal',
  },
  {
    key: 'facility',
    text: 'Facility',
    type: 'normal',
  },
  {
    key: 'sinkingFund',
    text: 'Sinking Fund',
    type: 'normal',
  },
  {
    key: 'commonFee',
    text: 'Common Fee',
    type: 'normal',
  },
]


// WEBPACK FOOTER //
// ./src/screens/CompareProject/tableData.js